import { render, staticRenderFns } from "./SidebarTwo.vue?vue&type=template&id=09527370&scoped=true"
import script from "./SidebarTwo.vue?vue&type=script&lang=ts"
export * from "./SidebarTwo.vue?vue&type=script&lang=ts"
import style0 from "./SidebarTwo.vue?vue&type=style&index=0&id=09527370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09527370",
  null
  
)

export default component.exports